<template>
  <button
    data-grid
    v-bind="{ ...$attrs, class: '' }"
    :type="type"
    class="defaultbutton btn grid--va-center grid--center"
    :class="{ 'defaultbutton--busy': busy }"
    @click="type === 'button' && $emit('has-clicked', true)"
  >
    <GlobalLoader
      v-if="busy"
      class="white"
    />

    <slot v-else>
      {{ text }}
    </slot>
  </button>
</template>

<script>
import { defineComponent } from 'vue'

import GlobalLoader from '../global/GlobalLoading'

export default defineComponent({
  name: 'DefaultButton',

  components: {
    GlobalLoader
  },

  props: {
    text: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: () => 'button'
    },

    busy: {
      type: Boolean,
      default: false
    }
  },

  emits: ['has-clicked']
})
</script>

<style lang="scss" scoped>
  :deep(.global-loader) div {
    background-color: var(--color) !important;
  }

  .defaultbutton {
    --color: rgb(var(--white));
    --width: min(100%, 212px);
    --iconWidth: 20px;

    padding: 0 20px;
    border-radius: 80px;
    height: 40px;
    width: var(--width);
    background-color: var(--primary);
    font: normal 700 1.4rem "Nunito", sans-serif;

    &[disable] {
      opacity: 0.7;
      cursor: not-allowed;
    }

    &--busy {
      padding-inline: 0;
    }

    &--black {
      background-color: rgb(var(--black));
    }

    :slotted(svg) {
      margin-inline: 0 12px;
      width: var(--iconWidth);
      max-width: var(--iconWidth);
    }

    &.disabled {
      pointer-events: none;
    }

    .is-dark-theme &:disabled {
      opacity: .4;
      color: rgb(var(--gray6));
      background: rgb(var(--gray8));
    }
  }
</style>
